// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-align@2.4.1@rc-align/es/index.js
// module id = 435
// module chunks = 0 1